import React from "react";


export enum TypeAffichage {
  Societe = 1,
  Notice =2,
}


interface IProps {
  text?: string;
  jsxElement?: JSX.Element;
  typeAffichage?: TypeAffichage;
}


const renderIcon = (pTypeAffichage:TypeAffichage) => {
  switch (pTypeAffichage) {
    case TypeAffichage.Societe:
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="100%" fill="currentColor" className="bi bi-buildings" viewBox="0 0 16 16">
          <path d="M14.763.075A.5.5 0 0 1 15 .5v15a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V14h-1v1.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V10a.5.5 0 0 1 .342-.474L6 7.64V4.5a.5.5 0 0 1 .276-.447l8-4a.5.5 0 0 1 .487.022M6 8.694 1 10.36V15h5zM7 15h2v-1.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5V15h2V1.309l-7 3.5z"/>
          <path d="M2 11h1v1H2zm2 0h1v1H4zm-2 2h1v1H2zm2 0h1v1H4zm4-4h1v1H8zm2 0h1v1h-1zm-2 2h1v1H8zm2 0h1v1h-1zm2-2h1v1h-1zm0 2h1v1h-1zM8 7h1v1H8zm2 0h1v1h-1zm2 0h1v1h-1zM8 5h1v1H8zm2 0h1v1h-1zm2 0h1v1h-1zm0-2h1v1h-1z"/>
        </svg>
      );
    case TypeAffichage.Notice:
      return (
        <svg viewBox="0 0 240 240" xmlns="http://www.w3.org/2000/svg" className="electre_design-system_style_layout__dspl-block electre_design-system_style_layout__width vars-1057044457 electre_design-system_style_atom__icon-navy vars--795662912"><path d="M20,170H220.78v20H20Zm200.78,60H30.43A10.42,10.42,0,0,1,20,219.53V210H220.78ZM20,149.81c0-13.06,3.74-29,29.91-33.64C80.58,110.69,214.25,69.48,220.78,2.26,223.58,76,105,143.28,20,149.81Z"></path></svg>
      );
    default:
      return <></>;
  }
};

const CpntDetailsNotAccess: React.FC<IProps> = ({ text,jsxElement, typeAffichage}) => {
   return (
    <>
      <div>
        <div className="card pae-detail-pub-card">
          <div className="card-body pae-form-container row">
            <div className="col-xl-2  col-md-6  col-12 mt-2">
              {
                typeAffichage &&
                <div className="pae-detail-linked-file">
                  {renderIcon(typeAffichage)}
                </div>

              }
            </div>
            <div className="col-xl-10 col-md-6 col-12 mt-2 d-flex justify-content-center align-items-center">
              {text && text}
              {jsxElement && jsxElement}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CpntDetailsNotAccess;
